import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    computed,
    forwardRef,
    input,
    model,
    ViewEncapsulation,
} from '@angular/core';
import type { ControlValueAccessor } from '@angular/forms';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

let inputId = 1;

@Component({
    selector: 'ui-input-radio',
    templateUrl: './m020-c050-input-radio.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    host: {
        class: 'flex items-center gap-24 md:gap-40',
    },
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => InputRadioComponent), multi: true }],
})
export class InputRadioComponent<T extends string> implements ControlValueAccessor {
    inputId = `form-input-radio-${inputId++}`;

    options = input.required<Array<{ value: T; label: string }>>();
    withNullRadio = input(false, { transform: booleanAttribute });
    disabled = model(false);
    value = model<T | undefined>();

    radioButtons = computed(() => {
        const options = this.options();
        if (this.withNullRadio()) {
            return [{ value: undefined, label: 'Beliebig' }, ...options];
        }
        return options;
    });

    onChange?: (value: T | undefined) => void;
    onTouch?: () => void;

    writeValue(value: T | undefined) {
        this.value.set(value);
    }
    registerOnChange(fn: (value: T | undefined) => void) {
        this.onChange = fn;
    }
    registerOnTouched(fn: () => void): void {
        this.onTouch = fn;
    }
    setDisabledState?(isDisabled: boolean): void {
        this.disabled.set(isDisabled);
    }

    checkedChange(value: T | undefined) {
        this.value.set(value);
        this.onTouch?.();
        this.onChange?.(value);
    }
}
